import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import {
  ComparatorSelectionList,
  ComparatorTable,
  ComparatorTableContent,
  ComparatorTableRow,
  ComparatorTableRowLabel,
  ComparatorTableRowValue,
  ComparatorTableTooltip,
  ComparatorTableTrigger,
} from "@tudigo-monorepo/web-tudigo-comparator";

export function ProjectsComparatorAdvancedInformationsTable() {
  return (
    <ComparatorTable>
      <ComparatorTableTrigger>Informations avancées</ComparatorTableTrigger>
      <ComparatorTableContent>
        <ComparatorTableRow>
          <ComparatorTableRowLabel>Les fondateurs</ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue>
                {project.content?.founders ? project.content?.founders : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>Impact</ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue>
                {project.content?.impact ? project.content?.impact : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            Technologie / Innovation
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue>
                {project.content?.technologyAndInnovation
                  ? project.content?.technologyAndInnovation
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>Raisons de la levée</ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue>
                {project.content?.reasonsForFundraising
                  ? project.content.reasonsForFundraising
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            Exit envisagé et garanties
            <ComparatorTableTooltip>
              Stratégies de sortie envisagées pour les investisseurs.
            </ComparatorTableTooltip>
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue>
                {project.content?.exitAndGuarantees
                  ? project.content.exitAndGuarantees
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>
      </ComparatorTableContent>
    </ComparatorTable>
  );
}
